const THEME_KEY = 'engleet-theme';
const DARK = 'dark';
const LIGHT = 'light';

function prefersDark() {
  return (
    window.matchMedia &&
    window.matchMedia('(prefers-color-scheme: dark)').matches
  );
}

function isDark() {
  const theme = document.documentElement.getAttribute('data-theme');
  return theme === DARK || (theme === null && prefersDark());
}

function applyTheme(dark) {
  document.documentElement.setAttribute('data-theme', dark ? DARK : LIGHT);
}

function syncToggle(dark) {
  document.querySelectorAll('[data-theme-toggle]').forEach((btn) => {
    btn.setAttribute('aria-checked', String(dark));
    const icon = btn.querySelector('[data-theme-icon]');
    if (icon) {
      icon.classList.toggle('fa-sun', !dark);
      icon.classList.toggle('fa-moon', dark);
    }
  });
}

export function init(rootEl = document) {
  const saved = localStorage.getItem(THEME_KEY);
  const dark = saved === DARK || (saved === null && prefersDark());

  applyTheme(dark);
  syncToggle(dark);

  rootEl.querySelectorAll('[data-theme-toggle]').forEach((btn) => {
    btn.addEventListener('click', () => {
      const next = !isDark();
      applyTheme(next);
      localStorage.setItem(THEME_KEY, next ? DARK : LIGHT);
      syncToggle(next);
    });
  });
}
